module.exports = __webpack_public_path__ + "media/images/career_camp/2023/for_who_1-02b0096be3026b3ca84bd940ee95dc02.png";